
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13.334l-1.779-1.778M13.779 11.556L12 13.334M12 7.998v5.336M16.002 14.223v0c0 .982-.796 1.779-1.779 1.779H9.777A1.779 1.779 0 018 14.222v0"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.004"}})])
          )
        }
      }
    